import { ClubMemberProperty } from 'components/ClubMemberManagement/types';
import { useRouter } from 'next/router';
import useSWR, { SWRResponse } from 'swr';

type PropertyArray = Partial<ClubMemberProperty>[];

// Returns the club's custom member properties, optionally merged with the built-in member fields
export const useClubMemberFields = (
    all: boolean = true,
    clubSlug: string | null = null
): SWRResponse<{
    data: PropertyArray;
}> & { isLoading: boolean; fields: PropertyArray } => {
    const { query } = useRouter();
    clubSlug = clubSlug || (query.slug as string);
    const { data, error, ...rest } = useSWR<{
        data: PropertyArray;
    }>(clubSlug ? `club-member/${clubSlug}/property` : null);

    // Custom properties need the member management plan — without it the request 403s and we
    // fall back to an empty list so the static fields below are still offered.
    let commulatedData: PropertyArray = Array.isArray(data?.data) ? data.data : [];
    const staticFields: PropertyArray = [
        { title: 'Name', key: 'name' },
        { title: 'Vorname', key: 'firstname' },
        { title: 'Nachname', key: 'lastname' },
        { title: 'Geschlecht', key: 'gender' },
        { title: 'E-Mail Adresse', key: 'email' },
        { title: 'Notizen', key: 'remarks' },
        { title: 'Telefonnummer', key: 'phone' },
        { title: 'Geburtstag', key: 'birthday' },
        { title: 'Eintrittsdatum', key: 'entry_date' },
        { title: 'Straße und Hausnummer', key: 'street_complete' },
        { title: 'Straße', key: 'street' },
        { title: 'Hausnummer', key: 'streetnumber' },
        { title: 'PLZ', key: 'postalcode' },
        { title: 'Stadt', key: 'city' }
    ];

    if (all) {
        commulatedData = commulatedData.concat(staticFields);
    }

    return {
        fields: commulatedData,
        isLoading: !data && !error,
        data: { data: commulatedData },
        error,
        ...rest
    };
};
